module.exports = {"120118001":"华康街道","120118100":"静海镇","120118101":"唐官屯镇","120118102":"独流镇","120118103":"王口镇","120118104":"台头镇","120118105":"子牙镇","120118106":"陈官屯镇","120118107":"中旺镇","120118108":"大邱庄镇","120118109":"蔡公庄镇","120118110":"梁头镇","120118111":"团泊镇","120118112":"双塘镇","120118113":"大丰堆镇","120118114":"沿庄镇","120118115":"西翟庄镇","120118200":"良王庄乡","120118201":"杨成庄乡","120118400":"天津静海经济开发区","120118402":"天津子牙循环经济产业区","120118403":"团泊新城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120118.json
// module id = 54
// module chunks = 0